import { useMemo } from "react";
import DOMPurify from "dompurify";
import { cn } from "@/lib/utils";

// Equivalente ao ng-bind-html do legado, que passava pelo $sanitize do
// ngSanitize. HTML vindo do backend (corpo de notificação, mensageria...) nunca
// vai cru para dangerouslySetInnerHTML.
export function HtmlSeguro({ html, className }: { html?: string | null; className?: string }) {
  const limpo = useMemo(() => DOMPurify.sanitize(html ?? ""), [html]);
  return <div className={cn("[&_a]:text-primary [&_a]:underline", className)} dangerouslySetInnerHTML={{ __html: limpo }} />;
}
